import {updateArtisanPrice} from './update';

$(document).on('change', '.artisan_price', function () {
    renderLoadingOverlay()
    const artisan_price_list_item_id = $(this).attr('artisan-price-list-item-id')
    const price_column    = $(this).attr('price-column')
    const value           = $(this).val()

    updateArtisanPrice(artisan_price_list_item_id, price_column, value);
})
